//Копия persistStateEdbo.js

const createSlicer = (paths) => {
  return (state) => {
    let subset = {};

    paths.forEach((key) => {
      let slice = state[key];
      if (slice) subset[key] = slice;
    });

    return subset;
  };
};

const mergeState = (initialState, persistedState) => {
  return persistedState
    ? { ...initialState, ...persistedState }
    : initialState;
};

export default function persistState(paths, config) {
  const cfg = {
    key: 'redux',
    merge: mergeState,
    slicer: createSlicer,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    ...config
  };

  const {
    key,
    merge,
    slicer,
    serialize,
    deserialize
  } = cfg;

  const ls_get = () => deserialize(localStorage.getItem(key));

  return (createStore) => (reducer, initialState, enhancer) => {
    if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
      enhancer = initialState;
      initialState = undefined;
    }

    let persistedState;
    let finalInitialState;

    try {
      persistedState = ls_get();
      finalInitialState = merge(initialState, persistedState);
    } catch (e) {
      console.warn('Failed to retrieve initialize state from localStorage:', e);
    }

    const store = createStore(reducer, finalInitialState, enhancer);
    const slicerFn = slicer(paths);

    store.subscribe(function () {
      const state = store.getState();
      const subset = slicerFn(state);
      //const oldStored = ls_get();
      // don't set local storage if it has other token now (other tab relogin) + isTabUserBlock
      // not detecting logout (!oldStored.token) because that makes it trigger on normal login

      //Пока не переношу это в кабинет
      /*if (!state.isTabUserBlock) {
        if (oldStored && oldStored.token && state.token && (oldStored.token.access_token !== state.token.access_token)) {
          store.dispatch({ type: 'LOGIN_TAB_USER_BLOCK' });
          return;
        }*/

        try {
          localStorage.setItem(key, serialize(subset));
        } catch (e) {
          console.warn('Unable to persist state to localStorage:', e);
        }
      //}
    });

    return store;
  }
}